import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let CulturalRelicsFields = {
    'category': {
        display: {
            name: '種類',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'category',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['文物-產品包裝','文物-產業器具','文物-紀念物品 ',
                    '文物-書畫藝品','文物-民俗器物','文物-行政器物',
                    '文物-生活器物','文物-教育器物','文物-其他',
                    '器具-生產設施','器具-動力設施','器具-輔助設施',
                    '器具-服務設施','器具-行政設施','器具-其他'].map(x=>({value:x, label:x})),
            }
        }
    },
    'era_ad': {
        display: {
            name: '年代(西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'era_none_ad': {
        display: {
            name: '年代(非西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_none_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'structure_material': {
        display: {
            name: '構造/材料',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'structure_material',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multiple-select-as-is',
            options: {
                type: 'fixed',
                list: ['木材','磚造','R.C','金屬','陶瓷','塑膠','玻璃','紙類'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'format_size_length': {
        display: {
            name: '尺寸-長',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_length',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'format_size_width': {
        display: {
            name: '尺寸-寬',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_width',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'format_size_height': {
        display: {
            name: '尺寸-高',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_height',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'format_size_unit': {
        display: {
            name: '尺寸-單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'format_size_unit',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['公分','公尺'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'quantity': {
        display: {
            name: '數量',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'quantity',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'acquire_method': {
        display: {
            name: '取得方式',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'acquire_method',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['徵求','蒐訪','複製','採購','捐贈','交換','授權'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'acquire_date': {
        display: {
            name: '取得日期',
            type: 'datetime',
        },
        source: {
            type: 'db',
            key: 'acquire_date',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'provider': {
        display: {
            name: '提供者',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'provider',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'provider_contact': {
        display: {
            name: '提供者聯絡資訊',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'provider_contact',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'collect_man': {
        display: {
            name: '採集人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'collect_man',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'handle_man': {
        display: {
            name: '經手人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'handle_man',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    }
}

let CulturalRelics = (front_back) => {

    let fields = null

    if (front_back === 'backstage') {
        fields = [
            CulturalRelicsFields['category'],
            CulturalRelicsFields['era_ad'],
            CulturalRelicsFields['era_none_ad'],
            CulturalRelicsFields['structure_material'],
            CulturalRelicsFields['format_size_length'],
            CulturalRelicsFields['format_size_width'],
            CulturalRelicsFields['format_size_height'],
            CulturalRelicsFields['format_size_unit'],
            CulturalRelicsFields['quantity'],
            CulturalRelicsFields['acquire_method'],
            CulturalRelicsFields['acquire_date'],
            CulturalRelicsFields['provider'],
            CulturalRelicsFields['provider_contact'],
            CulturalRelicsFields['collect_man'],
            CulturalRelicsFields['handle_man'],
        ]
    }
    else {
        fields = [
            CulturalRelicsFields['category'],
            CulturalRelicsFields['era_ad'],
            CulturalRelicsFields['era_none_ad'],
            CulturalRelicsFields['structure_material'],
            CulturalRelicsFields['format_size_length'],
            CulturalRelicsFields['format_size_width'],
            CulturalRelicsFields['format_size_height'],
            CulturalRelicsFields['format_size_unit'],
            CulturalRelicsFields['quantity'],
            CulturalRelicsFields['acquire_method'],
            CulturalRelicsFields['acquire_date'],
            CulturalRelicsFields['provider'],
            // CulturalRelicsFields['provider_contact'],
            // CulturalRelicsFields['collect_man'],
            // CulturalRelicsFields['handle_man'],
        ]
    }

    return {
        name: '文物器具資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('cultural_relics', front_back),
        ForestryData('cultural_relics', front_back),
        CulturalRelics(front_back), 
        Rights('cultural_relics', front_back), 
        PhysicalObject('cultural_relics', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '文物器具類',
        type: 'group',
        fields
    }    
}

  